export function Links() {
  return (
    <>
      <h1>{import.meta.env.LINKEEP_APP_NAME}</h1>
      <p>Coming soon…</p>
    </>
  )
}
